import React from 'react';
import { Link } from 'react-router-dom';

export const TechnicianPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 font-sans">
      <header className="border-b border-slate-800 bg-slate-950/80 backdrop-blur sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center gap-3">
            <img src="/official.png" alt="Verisure" className="h-9 w-auto object-contain" />
          </Link>
          <div className="flex items-center gap-4 text-xs font-bold">
            <Link to="/about" className="text-slate-400 hover:text-white transition">About Us</Link>
            <Link to="/terms" className="text-slate-400 hover:text-white transition">Terms</Link>
            <Link to="/login" className="bg-gradient-to-r from-red-600 to-orange-500 text-white px-4 py-2 rounded-xl">
              Sign In
            </Link>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-4xl space-y-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-orange-500/10 border border-orange-500/30 text-orange-400 text-xs font-bold rounded-full mb-3">
            Vetting & Integrity Standards
          </div>
          <h1 className="text-3xl md:text-5xl font-black text-white">Technician Code of Conduct</h1>
          <p className="text-slate-400 text-sm mt-2">Professional Standards, KYC Vetting & Anti-Fraud Compliance</p>
        </div>

        <div className="space-y-8 text-sm leading-relaxed text-slate-300 bg-slate-900/60 border border-slate-800 p-6 md:p-10 rounded-3xl">
          <section>
            <h2 className="text-lg font-bold text-white mb-2 text-orange-400">1. Verification & Accreditation</h2>
            <p>
              Every technician authorized to log maintenance on the Verisure platform must complete multi-tier verification:
            </p>
            <ul className="list-disc list-inside space-y-1.5 mt-2 text-slate-300">
              <li><strong>Government Identity Verification (KYC):</strong> Valid National ID, Driver's License, or International Passport.</li>
              <li><strong>Trade Certification:</strong> Verifiable technical diplomas, engineering licenses, or OEM manufacturer training certificates.</li>
              <li><strong>Service Specialization Classification:</strong> Categorization into specific equipment domains (Industrial, Electrical, Mechanical, Telecom, Automotive, HVAC, Consumer Electronics).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-2 text-orange-400">2. Anti-Fraud & Data Integrity Commitment</h2>
            <p>
              Technicians act as accredited forensic witnesses on the ledger. Technicians strictly agree:
            </p>
            <ul className="list-disc list-inside space-y-1.5 mt-2 text-slate-300">
              <li><strong>Zero Tolerance for False Claims:</strong> Logging fictitious repairs, using stock photos, or falsifying replaced components results in immediate account revocation and reporting to trade regulatory bodies.</li>
              <li><strong>Accurate Cost & Part Reporting:</strong> Invoiced costs and replacement parts must match actual equipment work performed.</li>
              <li><strong>Live On-Site GPS Logging:</strong> Inspections must be logged on-site using GPS telemetry to verify physical inspection of the target equipment.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-2 text-orange-400">3. Customer Review & Ratings Transparency</h2>
            <p>
              Equipment owners submit verified ratings and reviews after each logged repair. A technician’s aggregate rating, completed repair count, and insurer audit compliance score are published transparently on their public Verisure profile.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-2 text-orange-400">4. Dispute Resolution</h2>
            <p>
              If an equipment owner or insurer disputes a repair log, Verisure initiates an independent forensic review of the photographic metadata, GPS timestamps, and part serials. Technicians are obligated to provide clarifying diagnostic documentation upon request.
            </p>
          </section>
        </div>
      </main>

      <footer className="py-10 border-t border-slate-800 text-center text-xs text-slate-500">
        <p>&copy; {new Date().getFullYear()} VERISURE • Equipment Maintenance Tracking & Insurance Evidence.</p>
      </footer>
    </div>
  );
};
